<template>
    <v-app class="blog-page blog-article" itemscope itemtype="http://schema.org/BlogPosting">
        <v-container class="blog-article__container">
            <v-layout class="blog-article__breadcrumbs">
                <ul class="breadcrumb" itemscope itemtype="https://schema.org/BreadcrumbList">
                    <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                        <a href="/blog">Блог</a>
                        <meta itemprop="position" content="1" />
                        <meta itemprop="item" :content="getOriginUrl('/blog')" />
                        <meta itemprop="name" content="Блог" />
                    </li>
                    <li v-if="categories.length" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                        <a :href="'/blog?categories=' + categories[0].id" v-html="categories[0].name"></a>
                        <meta itemprop="position" content="2" />
                        <meta itemprop="item" :content="getOriginUrl('/blog?categories=' + categories[0].id)" />
                        <meta itemprop="name" :content="categories[0].name" />
                    </li>
                    <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                        {{ article.name }}
                        <meta itemprop="position" content="3" />
                        <meta itemprop="name" :content="article.name" />
                    </li>
                </ul>
            </v-layout>
        </v-container>
        <v-layout
            :class="['blog-article__title-block', innerImage ? '' : 'no-image']"
            :style="innerImage ? `background-image: url(${getUrl()})` : ''"
        >
            <v-container class="blog-article__title-block__container">
                <v-layout wrap row class="blog-article__title-block__content">
                    <v-flex column xs12 lg8 >
                        <time class="blog-article__title-block__content__date" v-html="getDate()" itemprop="datePublished" :datetime="getDateISO()">
                        </time>
                        <v-flex>
                            <h1 itemprop="headline">
                                {{ article.name }}
                            </h1>
                        </v-flex>
                        <v-flex class="blog-article__title-block__content__categories" v-if="categories.length > 0">
                            <a
                                :class="'mr-5'"
                                v-for="category in categories"
                                :key="'category' + category.id"
                                :href="getCategoryUrl(category.id)"
                                v-html="category.name"
                            >
                            </a>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-layout>
        <v-container class="blog-page blog-article__container">
            <v-layout row wrap class="blog-article__container__inner">
                <v-flex hidden-lg-and-up xs12 mb-5 :ref="'navBar'" class="blog-article__navigation-block">
                    <v-flex
                        d-flex class="blog-article__navigation"
                        v-for="(item, index) in navigation"
                        :key="index"
                        :ref="'nav' + index"
                        @click="clickNavItem($event, index)"
                    >
                        <v-flex class="blog-article__navigation__count"><span>{{index+1}}</span><span> — </span></v-flex>
                        <v-flex ml-2>
                            <span v-html="item"></span>
                        </v-flex>
                    </v-flex>
                </v-flex>
                <v-flex
                    xs12 lg8 class="blog-article__content-block"
                    v-html="article.text"
                    :ref="'articleText'"
                    itemprop="articleBody"
                >
                </v-flex>
                <v-flex hidden-md-and-down xs12 lg3 offset-lg1 :ref="'navBar'" class="blog-article__navigation-block">
                    <v-flex
                        d-flex class="blog-article__navigation"
                        v-for="(item, index) in navigation"
                        :key="index"
                        :ref="'nav' + index"
                        @click="clickNavItem($event, index)"
                    >
                        <v-flex class="blog-article__navigation__count"><span>{{index+1}}</span><span> — </span></v-flex>
                        <v-flex ml-2>
                            <span v-html="item"></span>
                        </v-flex>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-container>

        <Qna
            :qna="qna"
            :categories="categories"
        />

        <v-container class="blog-page">
            <v-layout row wrap class="blog-article__banner">
                <v-flex xs12 md7>
                    <h2>В среднем клиенты экономят при покупке полиса ОСАГО</h2>
                    <div class="blog-article__banner__sum">783 Р</div>
                    <p>Экономия досигается за счет сравнения предложений в разных страховых компаниях c учетом отличия базовх тарифов + - 20%.</p>
                    <a href="https://getpolis.ru" class="blog-button blog-white-button">Оформить</a>
                </v-flex>
                <v-flex xs12 md5>
                    <img
                        :src="'/png/pig.png'"
                    />
                </v-flex>
            </v-layout>
        </v-container>

        <v-container class="blog-page blog-recommend" v-if="recommends.length > 0">
            <h2>Вам также будет интересно</h2>
            <v-layout wrap class="blog-recommend__inner">
                <v-flex
                    xs12 md4 class="blog-recommend__item"
                    v-for="article in recommends"
                    :key="'item' + article.id"
                >
                    <v-flex xs12 v-if="article.img">
                        <v-img :src="getImageUrl(article.img)" class="blog-recommend__item__image" alt=""></v-img>
                    </v-flex>
                    <v-flex xs12>
                        <h3>{{ article.name }}</h3>
                        <a :href="getPermalink(article.id)" class="blog-button">Читать статью</a>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
    </v-app>
</template>
<script>
import moment from "moment";
import Qna from './Qna'

export default {
    props: ['article', 'categories', 'qna', 'recommends'],

    components: {
        Qna
    },

    data: () => ({
        innerImage: null,
        navigation: [],
    }),

    mounted () {
        this.innerImage = this.article.img_inner ? this.article.img_inner : null
        this.setNavigation()

        this.$nextTick(() => {
            this.$refs.navBar.style.width = this.$refs.navBar.clientWidth + 'px'
            this.$refs.navBar.style.height = this.$refs.navBar.clientHeight + 'px'
        })
    },

    created: () => {
    },

    methods: {
        getOriginUrl(url) {
            return window.location.origin + url
        },

        getUrl() {
            return window.location.origin + '/' + this.innerImage
        },

        setNavigation() {
            if(this.article){
                this.navigation = this.article.text.match(/<h2>(.*?)<\/h2>/g)
                if(this.navigation){
                    this.navigation = this.navigation.map((item) => {
                        return item.replace(/(<([^>]+)>)/ig, "");
                    })
                }
            }
        },

        clickNavItem(event, index) {
            let res = this.$refs.articleText.getElementsByTagName('h2')[index]
            this.goToElement(res)
        },

        goToElement(selector) {
            this.$vuetify.goTo(selector, {
                duration: 600,
                offset: 150,
                easing: 'easeInCubic',
            });
        },

        handleScroll(event) {
        },

        getPermalink(id) {
            return `/blog/article/${id}`
        },

        getImageUrl(img) {
            return window.location.origin + '/' + img
        },

        getCategoryUrl(id) {
            return window.location.origin + `/blog?categories=${id}`
        },

        getDateISO() {
            return moment(this.article.published_at).toISOString()
        },

        getDate() {
            if(this.article){
                return moment(this.article.published_at).format('DD.MM.YYYY')
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/blog/Article.vue